import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from "../components/HelloWorld";
import Liste from "../components/Liste";
import Import from "../components/Import";
import Charge from "../components/Charge";
import TableFinance from "../components/TableFinance";
import TableFinanceur from "../components/TableFinanceur";
import Export from "../components/Export";
import Marges from "../components/Marges";
import ExportFDT from "@/components/FDT/ExportFDT";
import TableSuiviRT from "@/components/PROJET/TableSuiviRT";
import TablePhase from "@/components/TablePhase";
import WeekTimesheet from "@/components/PROJET/WeekTimesheet.vue"
import ReconciliationFdtFrais from "@/components/PROJET/ReconciliationFdtFrais.vue"
import MigrationSalaries from "@/components/MigrationSalaries.vue"



Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/liste',
            name: 'Liste',
            component: Liste
        },
        {
            path: '/projet',
            name: 'Saisie',
            component: HelloWorld
        },
        {
            path: '/import',
            name: 'Import',
            component: Import
        },
        {
            path: '/charge',
            name: 'Charge',
            component: Charge
        },
        {
            path: '/tableau-phase',
            name: 'Tableau phase',
            component: TablePhase
        },
        {
            path: '/tableau-financier',
            name: 'Tableau financier',
            component: TableFinance
        },
        {
            path: '/tableau-financeur',
            name: 'Tableau financeur',
            component: TableFinanceur
        },
        {
            path: '/export',
            name: 'Export',
            component: Export
        },
        {
            path: '/marges',
            name: 'Marges',
            component: Marges
        },
        {
            path: '/exportfdt',
            name: 'Export FdT',
            component: ExportFDT
        },
        {
            path: '/tablesuivirt',
            name: 'Suivi temps réel',
            component: TableSuiviRT
        },
        {
            path: '/weektimesheet',
            name: 'État des validations',
            component: WeekTimesheet
        },
        {
            path: '/reconciliationfdtfrais',
            name: 'Réconciliation FDT FRAIS',
            component: ReconciliationFdtFrais
        },
        {
            path: '/migration',
            name: 'Migration salariés',
            component: MigrationSalaries
        }
    ]
})
